export default function parseUtmMediumFromUrlSearchParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.get('utm_medium');
}